<template>
  <div>
    <div
      class="fixed md:top-0 md:bottom-auto bottom-0 left-0 md:w-[500px] md:p-8 md:pt-10 md:pb-24 p-4 w-full bg-white z-50 shadow-lg transition-transform transform rounded-r-2xl max-h-screen overflow-y-auto"
      :class="{
        'md:-translate-x-full md:translate-y-0 translate-y-full': !sliderOpen,
        'md:translate-x-0 translate-y-0': sliderOpen,
      }"
      @click.stop
    >
      <div class="flex flex-col gap-6">
        <div class="w-full flex items-center justify-between">
          <div class="">
            <h1 class="font-belgiano text-2xl text-[#181818]">
              Schedule Charge
            </h1>
            <p class="font-inter text-sm text-[#645D5D]">
              Please provide your details below
            </p>
          </div>
          <span @click="closeSlider">
            <GreyCloseIcon />
          </span>
        </div>
        <div class="w-full flex gap-3 items-start" v-if="station">
          <GreyQorayLogo class="w-[40px] h-[40px]" />
          <div class="">
            <h4 class="font-inter font-semibold text-lg">
              {{ station.name }}
            </h4>
            <p class="font-inter text-base text-[#5E5E5E]">
              {{ station.address }}
            </p>
          </div>
        </div>
        <form class="w-full flex flex-col gap-4">
          <div class="w-full" v-if="!station">
            <label>Station</label>
            <div class="formInput">
              <select
                v-if="stations?.length"
                class="block w-full border-none outline-none"
                @change="selectStation($event.target.value)"
              >
                <option disabled selected value="">
                  Select Charge Station
                </option>
                <option
                  v-for="(station, index) in stations"
                  :key="index"
                  :value="station.slug"
                >
                  {{ station.name }}
                </option>
              </select>
            </div>
            <p>{{ errs.station }}</p>
          </div>
          <div class="w-full">
            <label>Full Name</label>
            <input v-model="name" type="text" class="formInput" />
            <p>{{ errs.name }}</p>
          </div>
          <div class="w-full">
            <label>Email Address</label>
            <input v-model="email" type="email" class="formInput" />
            <p>{{ errs.email }}</p>
          </div>
          <div class="w-full">
            <label>Phone Number</label>
            <input v-model="phone_number" type="text" class="formInput" />
            <p>{{ errs.phone_number }}</p>
          </div>
          <div class="w-full">
            <label>Preferred Date</label>
            <input v-model="date" class="formInput" :min="today" type="date" />
            <p>{{ errs.date }}</p>
          </div>
          <div class="w-full">
            <label>Preferred Time</label>
            <input v-model="time" class="formInput" type="time" />
            <p>{{ errs.time }}</p>
          </div>
        </form>
        <button
          class="black-btn w-full mt-6 py-3 disabled:cursor-not-allowed disabled:opacity-45"
          :disabled="loading"
          @click.prevent="submit"
        >
          {{ loading ? "Loading..." : "Submit Booking" }}
        </button>
      </div>
    </div>
    <div
      v-if="sliderOpen"
      class="fixed inset-0 z-40"
      @click="closeSlider"
    ></div>
  </div>
</template>

<script>
import GreyCloseIcon from "./GreyCloseIcon.vue";
import GreyQorayLogo from "./GreyQorayLogo.vue";
export default {
  components: { GreyQorayLogo, GreyCloseIcon },
  props: ["sliderOpen", "stations", "closeSlider"],
  data() {
    return {
      // Add any additional data properties here
      loading: false,
      name: "",
      phone_number: "",
      email: "",
      date: "",
      time: "",
      errs: {
        name: "",
        phone_number: "",
        email: "",
        date: "",
        time: "",
      },
    };
  },
  computed: {
    payload() {
      return {
        station: this.station ? this.station.slug : "",
        name: this.name,
        phone: this.phone_number,
        email: this.email,
        // date: this.date,
        // time: this.time,
        date_time: new Date(`${this.date}T${this.time}`),
      };
    },
    today() {
      // Get today's date
      const today = new Date();
      today.setDate(today.getDate() + 1);
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const dd = String(today.getDate()).padStart(2, "0");

      // Format the date as YYYY-MM-DD
      const formattedToday = `${yyyy}-${mm}-${dd}`;
      return formattedToday;
    },
    station() {
      var id = this.$store.getters.selectedStation;
      // console.log(this.stations);
      if (!id) {
        return null;
      }

      const selectedStation = this.stations.find(
        (station) => station.slug === id
      );

      if (!selectedStation) {
        return null;
      }
      // console.log(selectedStation);
      return { ...selectedStation };
    },
  },
  methods: {
    selectStation(station) {
      this.$store.commit("setSelectedStation", station);
    },
    success() {
      this.$store.dispatch("modalSuccess", {
        title: "Request Submitted",
        top: `Your submission has been received.`,
        bottom: "A sales rep will reach out to you in 72 hours",
      });
    },
    validateForm() {
      this.errs = {
        station: "",
        name: "",
        phone_number: "",
        email: "",
        date: "",
        time: "",
      };
      var rege = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (!this.station) {
        this.errs.station = "Please select a station";
        return false;
      }
      if (this.name.length < 2) {
        this.errs.name = "Name is too short";
        return false;
      } else if (!this.email.length || !this.email.match(rege)) {
        this.errs.email = "Invalid Email";
        return false;
      } else if (this.phone_number.length < 10) {
        this.errs.phone_number = "Invalid Phone Number";
        return false;
      } else if (
        !this.date.length ||
        new Date(this.date) < new Date(this.today)
      ) {
        this.errs.date = "Date must be tomorrow upwards";
        return false;
      } else if (!this.time.length) {
        this.errs.time = "Field is required";
        return false;
      } else {
        return true;
      }
    },
    async submit() {
      if (this.validateForm() === true) {
        this.loading = true;
        try {
          fetch(process.env.VUE_APP_API_URL + "/schedule", {
            method: "POST",
            body: JSON.stringify({ ...this.payload }),
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .then(async (response) => {
              console.log(response);

              if (response.success) {
                var body = {
                  form: "charge",
                  payload: {
                    user_name: this.payload.name,
                    phone: this.payload.phone_number,
                    email: this.payload.email,
                    date: this.payload.date,
                    time: this.payload.time,
                    station: this.station.name,
                  },
                };
                await this.$store.dispatch("sendMail", body);
                this.success();
                this.loading = false;
                this.closeSlider();
              }
            })
            .catch((err) => {
              alert("something went wrong, please try again");
              this.loading = false;
            });
        } catch (error) {
          alert("something went wrong, please try again");
          this.loading = false;
          console.log(error);
        }
      }
    },
  },
  watch: {
    sliderOpen(newVal) {
      if (newVal) {
        return (document.body.style.overflow = "hidden");
      } else {
        return (document.body.style.overflow = "auto");
      }
    },
  },
};
</script>

<style scopred>
label {
  @apply font-inter font-medium text-sm;
}
.formInput {
  @apply mt-1 py-[18px] px-4 border border-[#D0D5DD] rounded-md block w-full outline-none;
}
form p {
  @apply text-red text-xs;
}
</style>